import type { ReactNode } from "react";
import textStyles from "../Text/Text.module.css";
import styles from "./TextButton.module.css";

interface Props {
  size?: "small" | "standard" | "large" | "xlarge" | "xxlarge" | "xxxlarge";
  children: ReactNode;
  disabled?: boolean;
  onClick(): void;
  tone?: "standard" | "weak";
  ariaLabel?: string;
}

export function TextButton(props: Props): React.ReactNode {
  const { onClick, tone = "standard" } = props;
  const classes: string[] = [styles.textButton, styles[`tone-${tone}`]];

  classes.push(textStyles[`textSize-${props.size || "standard"}`]);

  return (
    <button
      className={classes.join(" ")}
      type="button"
      onClick={onClick}
      disabled={props.disabled}
      aria-label={props.ariaLabel}
    >
      {props.children}
    </button>
  );
}
